var _excluded = ["selectedItems", "itemToString"],
    _excluded2 = ["getDropdownProps"],
    _excluded3 = ["getToggleButtonProps", "isOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useSelect, useMultipleSelection } from 'downshift';
import { useDropdown } from '.';
import { defaultLabelGetter } from '../helpers/defaultGetters';

/**
 * A hook used to manage all logic needed for a multiple select Dropdown.
 */
export default (function (_ref) {
  var selectedItemsProp = _ref.selectedItems,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return defaultLabelGetter(item);
  } : _ref$itemToString,
      props = _objectWithoutProperties(_ref, _excluded);

  var useMultipleSelectionArgs = {};

  if (selectedItemsProp) {
    // Setting this to undefined results in "cannot get length of undefined", so do this hack
    useMultipleSelectionArgs.selectedItems = selectedItemsProp;
  }

  var _useMultipleSelection = useMultipleSelection(_objectSpread(_objectSpread({}, useMultipleSelectionArgs), props)),
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      useMultipleSelectionReturnValue = _objectWithoutProperties(_useMultipleSelection, _excluded2);

  var stateReducer = function stateReducer(state, _ref2) {
    var changes = _ref2.changes,
        type = _ref2.type;

    switch (type) {
      case useSelect.stateChangeTypes.MenuKeyDownEnter:
      case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
      case useSelect.stateChangeTypes.ItemClick:
        return _objectSpread(_objectSpread({}, changes), {}, {
          isOpen: true,
          // keep menu open after selection
          highlightedIndex: state.highlightedIndex // maintain highlighted item after selection

        });

      default:
        return changes;
    }
  };

  var onStateChange = function onStateChange(_ref3) {
    var type = _ref3.type,
        selectedItem = _ref3.selectedItem;

    switch (type) {
      case useSelect.stateChangeTypes.MenuKeyDownEnter:
      case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
      case useSelect.stateChangeTypes.ItemClick:
        if (selectedItem && !useMultipleSelectionReturnValue.selectedItems.includes(selectedItem)) {
          useMultipleSelectionReturnValue.addSelectedItem(selectedItem);
        } else {
          useMultipleSelectionReturnValue.removeSelectedItem(selectedItem);
        }

        break;

      default:
        break;
    }
  };

  var _useDropdown = useDropdown(_objectSpread({
    selectedItem: null,
    itemToString: itemToString,
    stateReducer: stateReducer,
    onStateChange: onStateChange,
    layoutDependency: useMultipleSelectionReturnValue.selectedItems.length
  }, props)),
      rawGetToggleButtonProps = _useDropdown.getToggleButtonProps,
      isOpen = _useDropdown.isOpen,
      useDropdownReturnValue = _objectWithoutProperties(_useDropdown, _excluded3);

  var getToggleButtonProps = function getToggleButtonProps(options, extraOptions) {
    return rawGetToggleButtonProps(_objectSpread({}, getDropdownProps(_objectSpread({
      preventKeyAction: isOpen
    }, options), extraOptions)));
  };

  return _objectSpread(_objectSpread({
    isOpen: isOpen,
    getToggleButtonProps: getToggleButtonProps
  }, useMultipleSelectionReturnValue), useDropdownReturnValue);
});
//# sourceMappingURL=useMultiDropdown.js.map